/**
 * Owner: Masa Bayu
 * File: typography-registry.ts
 * Date:Time: 2026-09-20 00:59
 * Description: Script → QXTypographySystem mapping — Batch 7 regional.
 */
import { assertScriptId } from './script-hints';
import { getRegisteredScript } from './script-registry';
const DEFAULTS = Object.freeze([
    Object.freeze({
        scriptId: 'Latn',
        defaultFontFamilyId: 'qx-sans',
        fallbackFontFamilyIds: Object.freeze(['qx-serif', 'platform-sans']),
        shapingRequired: false,
    }),
    Object.freeze({
        scriptId: 'Arab',
        defaultFontFamilyId: 'qx-naskh',
        fallbackFontFamilyIds: Object.freeze(['qx-sans-arab', 'platform-arab']),
        shapingRequired: true,
    }),
    Object.freeze({
        scriptId: 'Hebr',
        defaultFontFamilyId: 'qx-hebrew',
        fallbackFontFamilyIds: Object.freeze(['platform-hebr']),
        shapingRequired: true,
    }),
    Object.freeze({
        scriptId: 'Cyrl',
        defaultFontFamilyId: 'qx-sans',
        fallbackFontFamilyIds: Object.freeze(['qx-serif', 'platform-sans']),
        shapingRequired: false,
    }),
    Object.freeze({
        scriptId: 'Grek',
        defaultFontFamilyId: 'qx-sans',
        fallbackFontFamilyIds: Object.freeze(['qx-serif', 'platform-sans']),
        shapingRequired: false,
    }),
    Object.freeze({
        scriptId: 'Hans',
        defaultFontFamilyId: 'qx-cjk-sans',
        fallbackFontFamilyIds: Object.freeze(['qx-cjk-serif', 'platform-cjk']),
        shapingRequired: false,
    }),
    Object.freeze({
        scriptId: 'Hant',
        defaultFontFamilyId: 'qx-cjk-sans',
        fallbackFontFamilyIds: Object.freeze(['qx-cjk-serif', 'platform-cjk']),
        shapingRequired: false,
    }),
    Object.freeze({
        scriptId: 'Jpan',
        defaultFontFamilyId: 'qx-cjk-sans',
        fallbackFontFamilyIds: Object.freeze(['qx-cjk-serif', 'platform-cjk']),
        shapingRequired: false,
    }),
    Object.freeze({
        scriptId: 'Kore',
        defaultFontFamilyId: 'qx-cjk-sans',
        fallbackFontFamilyIds: Object.freeze(['platform-cjk']),
        shapingRequired: false,
    }),
    Object.freeze({
        scriptId: 'Deva',
        defaultFontFamilyId: 'qx-deva',
        fallbackFontFamilyIds: Object.freeze(['platform-deva']),
        shapingRequired: true,
    }),
    Object.freeze({
        scriptId: 'Beng',
        defaultFontFamilyId: 'qx-beng',
        fallbackFontFamilyIds: Object.freeze(['platform-beng']),
        shapingRequired: true,
    }),
    Object.freeze({
        scriptId: 'Guru',
        defaultFontFamilyId: 'qx-guru',
        fallbackFontFamilyIds: Object.freeze(['platform-guru']),
        shapingRequired: true,
    }),
    Object.freeze({
        scriptId: 'Gujr',
        defaultFontFamilyId: 'qx-gujr',
        fallbackFontFamilyIds: Object.freeze(['platform-gujr']),
        shapingRequired: true,
    }),
    Object.freeze({
        scriptId: 'Orya',
        defaultFontFamilyId: 'qx-orya',
        fallbackFontFamilyIds: Object.freeze(['platform-orya']),
        shapingRequired: true,
    }),
    Object.freeze({
        scriptId: 'Taml',
        defaultFontFamilyId: 'qx-taml',
        fallbackFontFamilyIds: Object.freeze(['platform-taml']),
        shapingRequired: true,
    }),
    Object.freeze({
        scriptId: 'Telu',
        defaultFontFamilyId: 'qx-telu',
        fallbackFontFamilyIds: Object.freeze(['platform-telu']),
        shapingRequired: true,
    }),
    Object.freeze({
        scriptId: 'Knda',
        defaultFontFamilyId: 'qx-knda',
        fallbackFontFamilyIds: Object.freeze(['platform-knda']),
        shapingRequired: true,
    }),
    Object.freeze({
        scriptId: 'Mlym',
        defaultFontFamilyId: 'qx-mlym',
        fallbackFontFamilyIds: Object.freeze(['platform-mlym']),
        shapingRequired: true,
    }),
    Object.freeze({
        scriptId: 'Sinh',
        defaultFontFamilyId: 'qx-sinh',
        fallbackFontFamilyIds: Object.freeze(['platform-sinh']),
        shapingRequired: true,
    }),
    Object.freeze({
        scriptId: 'Thai',
        defaultFontFamilyId: 'qx-thai',
        fallbackFontFamilyIds: Object.freeze(['platform-thai']),
        shapingRequired: true,
    }),
    Object.freeze({
        scriptId: 'Laoo',
        defaultFontFamilyId: 'qx-lao',
        fallbackFontFamilyIds: Object.freeze(['platform-lao']),
        shapingRequired: true,
    }),
    Object.freeze({
        scriptId: 'Khmr',
        defaultFontFamilyId: 'qx-khmer',
        fallbackFontFamilyIds: Object.freeze(['platform-khmer']),
        shapingRequired: true,
    }),
    Object.freeze({
        scriptId: 'Mymr',
        defaultFontFamilyId: 'qx-myanmar',
        fallbackFontFamilyIds: Object.freeze(['platform-myanmar']),
        shapingRequired: true,
    }),
    Object.freeze({
        scriptId: 'Armn',
        defaultFontFamilyId: 'qx-armn',
        fallbackFontFamilyIds: Object.freeze(['platform-armn']),
        shapingRequired: false,
    }),
    Object.freeze({
        scriptId: 'Geor',
        defaultFontFamilyId: 'qx-geor',
        fallbackFontFamilyIds: Object.freeze(['platform-geor']),
        shapingRequired: false,
    }),
    Object.freeze({
        scriptId: 'Ethi',
        defaultFontFamilyId: 'qx-ethi',
        fallbackFontFamilyIds: Object.freeze(['platform-ethi']),
        shapingRequired: false,
    }),
    Object.freeze({
        scriptId: 'Tibt',
        defaultFontFamilyId: 'qx-tibt',
        fallbackFontFamilyIds: Object.freeze(['platform-tibt']),
        shapingRequired: true,
    }),
]);
const BY_SCRIPT = new Map(DEFAULTS.map((row) => [row.scriptId, row]));
export function listScriptFontDefaults() {
    return DEFAULTS;
}
export function getScriptFontDefaults(scriptId) {
    const id = assertScriptId(scriptId);
    return BY_SCRIPT.get(id);
}
export function resolveScriptFontDefaults(scriptId) {
    const id = assertScriptId(scriptId);
    const known = BY_SCRIPT.get(id);
    if (known) {
        return known;
    }
    // Unregistered script: generic last-resort mapping — not certified support
    const registered = getRegisteredScript(id);
    return Object.freeze({
        scriptId: id,
        defaultFontFamilyId: 'qx-sans',
        fallbackFontFamilyIds: Object.freeze(['platform-sans', 'last-resort-readable']),
        shapingRequired: registered?.familyId === 'arabic' ||
            registered?.familyId === 'indic' ||
            registered?.familyId === 'thai' ||
            registered?.familyId === 'lao' ||
            registered?.familyId === 'khmer' ||
            registered?.familyId === 'myanmar' ||
            registered?.familyId === 'tibetan',
    });
}
//# sourceMappingURL=typography-registry.js.map